export default {
  index: [
    {
      path: '/qyservice',
      component: resolve => require(['./qyserviceIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qyservice/_router.js